// extracted by mini-css-extract-plugin
export default {"headBand":"HeadBandList1St_headBand__hnGl7"};